// AUTO-EXTRACTED from SourceSecurity.com via Claude Sonnet 4.6 + Playwright MCP
// Generated: 2026-05-16
// Specs parsed from public product spec sheets; no values invented.
// All entries marked verified: false — reviewer must spot-check before promotion.

import type { EquipmentCatalogEntry } from '../equipmentCatalogEntry';

export const SS_ALARM_PANELS: EquipmentCatalogEntry[] = [
  {
    id: "ss-dsc-asg1000-1t5nas",
    manufacturer: "DSC",
    model: "ASG1000-1T5NAS",
    category: "alarm-panel",
    tagline: "DSC ASG1000-1T5NAS interactive hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-asg1000-1t5nas-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ASG","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-escort-5580tc",
    manufacturer: "DSC",
    model: "ESCORT 5580TC",
    category: "alarm-panel",
    tagline: "DSC ESCORT 5580TC automation control module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-escort-5580tc-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESCORT","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc4632",
    manufacturer: "DSC",
    model: "PC4632",
    category: "alarm-panel",
    tagline: "DSC PC4632 MAXSYS point graphic annunciators",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4632-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Maxsys Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-it-120",
    manufacturer: "DSC",
    model: "IT-120",
    category: "alarm-panel",
    tagline: "DSC IT-120 PowerSeries integration module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-it-120-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"IT-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-dsc-fsd-100",
    manufacturer: "DSC",
    model: "FSD-100",
    category: "alarm-panel",
    tagline: "DSC FSD-100 handheld test meter",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-fsd-100-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"FSD-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-it-100",
    manufacturer: "DSC",
    model: "IT-100",
    category: "alarm-panel",
    tagline: "DSC IT-100 PowerSeries integration module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-it-100-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"IT-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc5200",
    manufacturer: "DSC",
    model: "PC5200",
    category: "alarm-panel",
    tagline: "DSC PC5200 power supply module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5200-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc4664",
    manufacturer: "DSC",
    model: "PC4664",
    category: "alarm-panel",
    tagline: "DSC PC4664 point graphic annunciator",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4664-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-ws4979",
    manufacturer: "DSC",
    model: "WS4979",
    category: "alarm-panel",
    tagline: "DSC WS4979 4-button wireless wall plate",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ws4979-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"WS","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pc4701",
    manufacturer: "DSC",
    model: "PC4701",
    category: "alarm-panel",
    tagline: "DSC PC4701 MAXSYS dual-line dialer module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4701-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Maxsys Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN"]},
  },
  {
    id: "ss-dsc-pc5900",
    manufacturer: "DSC",
    model: "PC5900",
    category: "alarm-panel",
    tagline: "DSC PC5900 audio verification module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5900-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-wp-433",
    manufacturer: "DSC",
    model: "WP-433",
    category: "alarm-panel",
    tagline: "DSC WP-433 wireless device programmer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-wp-433-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"WP-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pc4401",
    manufacturer: "DSC",
    model: "PC4401",
    category: "alarm-panel",
    tagline: "DSC PC4401 MAXSYS data interface module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4401-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-hsm2204",
    manufacturer: "DSC",
    model: "HSM2204",
    category: "alarm-panel",
    tagline: "DSC HSM2204 high current output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hsm2204-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc4216",
    manufacturer: "DSC",
    model: "PC4216",
    category: "alarm-panel",
    tagline: "DSC PC4216 output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4216-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc4116",
    manufacturer: "DSC",
    model: "PC4116",
    category: "alarm-panel",
    tagline: "DSC PC4116 16 hardwire zone expanders",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4116-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-rm-2",
    manufacturer: "DSC",
    model: "RM-2",
    category: "alarm-panel",
    tagline: "DSC RM-2 end-of-line power supervisory relay",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-rm-2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"RM-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-it-230-rs-422",
    manufacturer: "DSC",
    model: "IT-230 RS-422",
    category: "alarm-panel",
    tagline: "DSC IT-230 RS-422 interface module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-it-230-rs-422-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Power Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-amp-701",
    manufacturer: "DSC",
    model: "AMP-701",
    category: "alarm-panel",
    tagline: "DSC AMP-701 addressable contact module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-amp-701-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AMP-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc5950",
    manufacturer: "DSC",
    model: "PC5950",
    category: "alarm-panel",
    tagline: "DSC PC5950 audio verification module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5950-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-hikvision-ds-pwa96-db-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA96-DB-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-DB-WB AX PRO Demo Box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-db-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-kit2-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-Kit2-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-Kit2-WE AX PRO Kit (868MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-kit2-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-db-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-DB-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-DB-WE AX PRO Demo Box",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-db-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa48-kit-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA48-Kit-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA48-Kit-WB AX PRO Kit (433MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa48-kit-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-m2h-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-M2H-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-M2H-WE AX PRO Ultra",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-m2h-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-m2-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-M2-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-M2-WE AX PRO with big battery size",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-m2-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-m2h-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA96-M2H-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-M2H-WB AX PRO Ultra",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-m2h-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hsgw-max1-zbs",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-ZBS IP Gateway with built-in ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max8-ex-lte-zw-sf1-sfv",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX8-EX-LTE-ZW-SF1-(SFV)",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX8-EX-LTE-ZW-SF1-(SFV) IP Gateway with built-in RF, LTE, and Z-Wave module,",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max8-ex-lte-zw-sf1-sfv-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-hmgw-max1-dt8-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX1-DT8-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-MAX1-DT8-ZBS IP-based alarm system with built-in ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max1-dt8-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pt4",
    manufacturer: "DSC",
    model: "- PT4",
    category: "alarm-panel",
    tagline: "DSC PT4 proximity tag",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pt4-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-hsm2300",
    manufacturer: "DSC",
    model: "HSM2300",
    category: "alarm-panel",
    tagline: "DSC HSM2300 power supply module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hsm2300-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-hsm2208",
    manufacturer: "DSC",
    model: "HSM2208",
    category: "alarm-panel",
    tagline: "DSC HSM2208 output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hsm2208-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-amp-702",
    manufacturer: "DSC",
    model: "AMP-702",
    category: "alarm-panel",
    tagline: "DSC AMP-702 addressable contact module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-amp-702-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AMP-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc5962",
    manufacturer: "DSC",
    model: "PC5962",
    category: "alarm-panel",
    tagline: "DSC PC5962 contoured audio station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5962-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc5961",
    manufacturer: "DSC",
    model: "PC5961",
    category: "alarm-panel",
    tagline: "DSC PC5961 stand-alone audio station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5961-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-escort4580",
    manufacturer: "DSC",
    model: "Escort4580",
    category: "alarm-panel",
    tagline: "DSC Escort4580 automation control module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-escort4580-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Escort","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-maxkit",
    manufacturer: "DSC",
    model: "- MAXKIT",
    category: "alarm-panel",
    tagline: "DSC MAXKIT access control kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-maxkit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-scw9045",
    manufacturer: "DSC",
    model: "SCW9045",
    category: "alarm-panel",
    tagline: "DSC SCW9045 self contained wireless alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-scw9045-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"SCW","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"users":17,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pc585",
    manufacturer: "DSC",
    model: "PC585",
    category: "alarm-panel",
    tagline: "DSC PC585 32 wireless zones",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc585-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"users":32,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-tr5164-433",
    manufacturer: "DSC",
    model: "TR5164-433",
    category: "alarm-panel",
    tagline: "DSC TR5164-433 PowerSeries 2-Way wireless transceiver module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-tr5164-433-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Power Series","zonesMax":60,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-wtk5504",
    manufacturer: "DSC",
    model: "WTK5504",
    category: "alarm-panel",
    tagline: "DSC WTK5504 2-way wireless touchscreen arming station",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-wtk5504-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"WTK","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-hs2128",
    manufacturer: "DSC",
    model: "HS2128",
    category: "alarm-panel",
    tagline: "Hybrid intrusion – Introducing powerful integrated solutions from PowerSeries Neo from DSC with Kant",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hs2128-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HS","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-amp-704",
    manufacturer: "DSC",
    model: "AMP-704",
    category: "alarm-panel",
    tagline: "DSC AMP-704 addressable contact module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-amp-704-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AMP-","zonesMax":4,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-hs2032",
    manufacturer: "DSC",
    model: "HS2032",
    category: "alarm-panel",
    tagline: "DSC HS2032 PowerSeries Neo control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hs2032-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HS","zonesMax":8,"zonesOnboard":0,"partitions":4,"grade":2,"users":72,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-hs2016",
    manufacturer: "DSC",
    model: "HS2016",
    category: "alarm-panel",
    tagline: "DSC HS2016 PowerSeries Neo control panels",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hs2016-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HS","zonesMax":0,"zonesOnboard":0,"partitions":2,"grade":2,"users":48,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pc5601",
    manufacturer: "DSC",
    model: "PC5601",
    category: "alarm-panel",
    tagline: "DSC PC5601 status module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc5601-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-hs2064",
    manufacturer: "DSC",
    model: "HS2064",
    category: "alarm-panel",
    tagline: "DSC HS2064 PowerSeries Neo control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-hs2064-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HS","zonesMax":8,"zonesOnboard":0,"partitions":8,"grade":2,"users":95,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-lcd5511",
    manufacturer: "DSC",
    model: "- LCD5511",
    category: "alarm-panel",
    tagline: "DSC LCD5511 - 64-ZONE LCD Powerseries control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-lcd5511-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerSeries","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-pc9155",
    manufacturer: "DSC",
    model: "PC9155",
    category: "alarm-panel",
    tagline: "DSC ALEXOR 2-way wireless panel - Security without compromise",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc9155-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PC","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-dsc-scw9057",
    manufacturer: "DSC",
    model: "SCW9057",
    category: "alarm-panel",
    tagline: "DSC IMPASSA self-contained 2-way wireless security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-scw9057-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"SCW","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"users":17,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-dsc-dsc-touch",
    manufacturer: "DSC",
    model: "DSC Touch",
    category: "alarm-panel",
    tagline: "DSC Touch 7-inch touchscreen smart panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-dsc-touch-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DSC","zonesMax":59,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-scw9047",
    manufacturer: "DSC",
    model: "SCW9047",
    category: "alarm-panel",
    tagline: "DSC SCW9047self-contained wireless alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-scw9047-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"SCW","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"users":17,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-ws4969",
    manufacturer: "DSC",
    model: "- WS4969",
    category: "alarm-panel",
    tagline: "DSC WS4969 4-Button Wireless Keys with Built-in Flashlight",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ws4969-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-ws4959",
    manufacturer: "DSC",
    model: "- WS4959",
    category: "alarm-panel",
    tagline: "DSC WS4959 Twelve-Channel, Five-Button Wireless Key",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ws4959-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dsc-ws4949",
    manufacturer: "DSC",
    model: "- WS4949",
    category: "alarm-panel",
    tagline: "DSC WS4949 Two-Button Wireless Key",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-ws4949-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dsc-pc4820",
    manufacturer: "DSC",
    model: "- PC4820",
    category: "alarm-panel",
    tagline: "DSC PC4820 Dual reader access control module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dsc-pc4820-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Maxsys Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-visonic-alarm-install",
    manufacturer: "Visonic",
    model: "Alarm Install",
    category: "alarm-panel",
    tagline: "Visonic Alarm Install mobile application",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-alarm-install-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Alarm","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-visonic-mct-330-332",
    manufacturer: "Visonic",
    model: "MCT-330/332",
    category: "alarm-panel",
    tagline: "Visonic MCT-330/332 wireless door/window contact",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-mct-330-332-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MCT-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-visonicgo",
    manufacturer: "Visonic",
    model: "VisonicGO",
    category: "alarm-panel",
    tagline: "Visonic VisonicGO mobile application",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-visonicgo-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VisonicGO","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-visonic-powermaster-360r",
    manufacturer: "Visonic",
    model: "PowerMaster-360R",
    category: "alarm-panel",
    tagline: "Visonic PowerMaster-360R wireless alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-powermaster-360r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerMaster-","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"users":48,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-visonic-powermaster-10-g2",
    manufacturer: "Visonic",
    model: "PowerMaster-10 G2",
    category: "alarm-panel",
    tagline: "Visonic PowerMaster-10 G2 wireless intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-powermaster-10-g2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerMaster-","zonesMax":30,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-powermaster-30-g2",
    manufacturer: "Visonic",
    model: "PowerMaster-30 G2",
    category: "alarm-panel",
    tagline: "PowerMaster-30 G2 PowerG-based Professional Wireless Alarm System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-powermaster-30-g2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerMaster-","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-powermaster-33-exp-g2",
    manufacturer: "Visonic",
    model: "PowerMaster-33 EXP G2",
    category: "alarm-panel",
    tagline: "Visonic PowerMaster-33 EXP G2 distributed wireless and wired alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-powermaster-33-exp-g2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerMaster-","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"users":48,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-visonic-hs2064",
    manufacturer: "Visonic",
    model: "HS2064",
    category: "alarm-panel",
    tagline: "Visonic HS2064 intruder alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2064-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerSeries Neo v1.3","zonesMax":8,"zonesOnboard":0,"partitions":8,"grade":2,"users":500,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-visonic-hs2016",
    manufacturer: "Visonic",
    model: "HS2016",
    category: "alarm-panel",
    tagline: "Visonic HS2016 intruder alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2016-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerSeries Neo v1.3","zonesMax":6,"zonesOnboard":0,"partitions":2,"grade":2,"users":48,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-visonic-powermaster-10",
    manufacturer: "Visonic",
    model: "PowerMaster-10",
    category: "alarm-panel",
    tagline: "PowerMaster-10: New PowerG-enabled wireless alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-powermaster-10-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerMaster-","zonesMax":30,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-hs2128",
    manufacturer: "Visonic",
    model: "HS2128",
    category: "alarm-panel",
    tagline: "Visonic HS2128 intruder alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hs2128-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PowerSeries Neo v1.3","zonesMax":8,"zonesOnboard":0,"partitions":8,"grade":2,"users":1000,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-visonic-hsm2host8",
    manufacturer: "Visonic",
    model: "HSM2HOST8",
    category: "alarm-panel",
    tagline: "Visonic HSM2HOST8 2-way wireless transceiver",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hsm2host8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-realalarm",
    manufacturer: "Visonic",
    model: "RealAlarm",
    category: "alarm-panel",
    tagline: "RealAlarm™ - Visual alarm verification solution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-realalarm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NVR2000 series","zonesMax":30,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-visonic-amberlink",
    manufacturer: "Visonic",
    model: "Amberlink",
    category: "alarm-panel",
    tagline: "Visonic Amberlink professional emergency response and safety monitoring system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-amberlink-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Amberlink","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-visonic-hsm2204vis",
    manufacturer: "Visonic",
    model: "HSM2204VIS",
    category: "alarm-panel",
    tagline: "Visonic HSM2204VIS high current output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hsm2204vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-visonic-hsm2208vis",
    manufacturer: "Visonic",
    model: "HSM2208VIS",
    category: "alarm-panel",
    tagline: "Visonic HSM2208VIS low current output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/visonic-hsm2208vis-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSM","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-lightsys",
    manufacturer: "RISCO Group",
    model: "LightSYS",
    category: "alarm-panel",
    tagline: "RISCO Group introduces the LightSYS Hybrid Security System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-lightsys-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"LightSYS","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-plug-in-ip-module",
    manufacturer: "RISCO Group",
    model: "Plug-in IP Module",
    category: "alarm-panel",
    tagline: "RISCO Group Plug-in IP Module primary communication",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-plug-in-ip-module-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Plug-in","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE"]},
  },
  {
    id: "ss-risco-group-digisense-pir",
    manufacturer: "RISCO Group",
    model: "DigiSense PIR",
    category: "alarm-panel",
    tagline: "RISCO Group DigiSense PIR Quad Technology Detector",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-digisense-pir-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DigiSense","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-digisense-pir-pet",
    manufacturer: "RISCO Group",
    model: "DigiSense PIR Pet",
    category: "alarm-panel",
    tagline: "RISCO Group DigiSense PIR Pet",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-digisense-pir-pet-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DigiSense","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-lightsys-voice-module",
    manufacturer: "RISCO Group",
    model: "LightSYS Voice Module",
    category: "alarm-panel",
    tagline: "RISCO Group LightSYS Voice Module multi-lingual",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-lightsys-voice-module-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"LightSYS","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-digisense-quad",
    manufacturer: "RISCO Group",
    model: "DigiSense Quad",
    category: "alarm-panel",
    tagline: "RISCO Group DigiSense Quad intruder detector",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-digisense-quad-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DigiSense","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-risco-group-wireless-beam-extension-kit",
    manufacturer: "RISCO Group",
    model: "Wireless Beam Extension Kit",
    category: "alarm-panel",
    tagline: "RISCO Group Wireless Beam Extension Kit one way transmitter",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/risco-group-wireless-beam-extension-kit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Wireless","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-texecom-premier-816-plus",
    manufacturer: "Texecom",
    model: "Premier 816 Plus",
    category: "alarm-panel",
    tagline: "Texecom Premier 816 Plus expandable control panel with modular accessories",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-816-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-48-w-complete-kit",
    manufacturer: "Texecom",
    model: "Premier Elite 48-W Complete Kit",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite 48-W Complete Kit - Wireless control panel kit with RICOCHET mesh technology",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-48-w-complete-kit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-texecom-premier-x10-com",
    manufacturer: "Texecom",
    model: "Premier X10-Com",
    category: "alarm-panel",
    tagline: "Texecom Premier X10-Com control panel module with connectivity to X10 power line interface",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-x10-com-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier Series","zonesMax":10,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-speech-module",
    manufacturer: "Texecom",
    model: "Premier Speech Module",
    category: "alarm-panel",
    tagline: "Texecom Premier Speech Module speech module with recordable audio messages",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-speech-module-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-comip",
    manufacturer: "Texecom",
    model: "Premier Elite ComIP",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite ComIP alarm system control panels with support for Texecom proximity tags",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-comip-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier Elite Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-key-fob-programmer",
    manufacturer: "Texecom",
    model: "Key-Fob Programmer",
    category: "alarm-panel",
    tagline: "Texecom Key-Fob data programmer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-key-fob-programmer-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Key-Fob","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-veritas-8",
    manufacturer: "Texecom",
    model: "Veritas 8",
    category: "alarm-panel",
    tagline: "Texecom Veritas 8 standalone control panel with 2 programmable part set suites",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-veritas-8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Veritas Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-24-ricochet-kit",
    manufacturer: "Texecom",
    model: "Premier Elite 24 Ricochet Kit",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite 24 Ricochet Kit 24 zone hybrid kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-24-ricochet-kit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":24,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-texecom-premier-elite-24",
    manufacturer: "Texecom",
    model: "Premier Elite 24",
    category: "alarm-panel",
    tagline: "Texecom releases Premier Elite control panels with new V2.02 firmware",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-24-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":3,"communicators":["wireless"]},
  },
  {
    id: "ss-texecom-premier-elite-mobile-apps",
    manufacturer: "Texecom",
    model: "Premier Elite Mobile Apps",
    category: "alarm-panel",
    tagline: "Texecom launches new Android apps for Premier Elite security systems",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-mobile-apps-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE"]},
  },
  {
    id: "ss-texecom-veritas-8-compact",
    manufacturer: "Texecom",
    model: "Veritas 8 Compact",
    category: "alarm-panel",
    tagline: "Texecom Veritas 8 Compact slimline discreet standalone control panel with latching walk test mode",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-veritas-8-compact-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Veritas Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-usb-com",
    manufacturer: "Texecom",
    model: "Premier Elite USB-Com",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite USB-Com interface connector",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-usb-com-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-48-ricochet-kit",
    manufacturer: "Texecom",
    model: "Premier Elite 48 Ricochet Kit",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite 48 Ricochet Kit - 48 zone hybrid kit with RICOCHET mesh technology",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-48-ricochet-kit-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-24-w",
    manufacturer: "Texecom",
    model: "Premier Elite 24-W",
    category: "alarm-panel",
    tagline: "The new Premier Elite 24-W control panel from Texecom",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-24-w-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":24,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-texecom-premier-elite-48-w",
    manufacturer: "Texecom",
    model: "Premier Elite 48-W",
    category: "alarm-panel",
    tagline: "Texecom introduces the Premier Elite 12-W Wireless Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-48-w-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier Elite Series","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-veritas-r8",
    manufacturer: "Texecom",
    model: "Veritas R8",
    category: "alarm-panel",
    tagline: "Texecom Veritas R8 control panel with 8 fully programmable zones",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-veritas-r8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Veritas Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-pc-com",
    manufacturer: "Texecom",
    model: "Premier Elite PC-Com",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite PC-Com serial interface connector",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-pc-com-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-texecom-premier-elite-usb-modem",
    manufacturer: "Texecom",
    model: "Premier Elite USB Modem",
    category: "alarm-panel",
    tagline: "Texecom Premier Elite USB Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/texecom-premier-elite-usb-modem-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Premier","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dmp-xr550dea-g",
    manufacturer: "DMP",
    model: "XR550DEA-G",
    category: "alarm-panel",
    tagline: "DMP XR550DEA-G Dialer & Encrypted Network Panel in Large Attack Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dea-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnl-g",
    manufacturer: "DMP",
    model: "XR550DNL-G",
    category: "alarm-panel",
    tagline: "DMP XR550DNL-G Dialer & Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnl-gz",
    manufacturer: "DMP",
    model: "XR550DNL-GZ",
    category: "alarm-panel",
    tagline: "DMP XR550DNL-GZ Dialer & Network Panel in Large Gray Enclosure, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnl-gz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550nl-g",
    manufacturer: "DMP",
    model: "XR550NL-G",
    category: "alarm-panel",
    tagline: "DMP XR550NL-G Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550nl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550epcb",
    manufacturer: "DMP",
    model: "XR550EPCB",
    category: "alarm-panel",
    tagline: "DMP XR550EPCB Encrypted Network Panel, Board Only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550epcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnpcb",
    manufacturer: "DMP",
    model: "XR150DNPCB",
    category: "alarm-panel",
    tagline: "DMP XR150DNPCB Dialer Panel, PCB only, with network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnpcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnl-r",
    manufacturer: "DMP",
    model: "XR550DNL-R",
    category: "alarm-panel",
    tagline: "DMP XR550DNL-R Dialer & Network Panel in Large Red Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnl-r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550del-g",
    manufacturer: "DMP",
    model: "XR550DEL-G",
    category: "alarm-panel",
    tagline: "DMP XR550DEL-G Dialer & Encrypted Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550del-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnpcb",
    manufacturer: "DMP",
    model: "XR550DNPCB",
    category: "alarm-panel",
    tagline: "DMP XR550DNPCB Dialer & Network Panel, Board Only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnpcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnpcbz-can",
    manufacturer: "DMP",
    model: "XR150DNPCBZ-CAN",
    category: "alarm-panel",
    tagline: "DMP XR150DNPCBZ-CAN Dialer Panel, with network, PCB only, no transformer, Canada",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnpcbz-can-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnl-g",
    manufacturer: "DMP",
    model: "XR150DNL-G",
    category: "alarm-panel",
    tagline: "DMP XR150DNL-G Dialer Panel, with network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnl-gcan",
    manufacturer: "DMP",
    model: "XR550DNL-GCAN",
    category: "alarm-panel",
    tagline: "DMP XR550DNL-GCAN Dialer & Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnl-gcan-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150nl-g",
    manufacturer: "DMP",
    model: "XR150NL-G",
    category: "alarm-panel",
    tagline: "DMP XR150NL-G Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150nl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnl-r",
    manufacturer: "DMP",
    model: "XR150DNL-R",
    category: "alarm-panel",
    tagline: "DMP XR150DNL-R Dialer Panel, With Network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnl-r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550del-gcan",
    manufacturer: "DMP",
    model: "XR550DEL-GCAN",
    category: "alarm-panel",
    tagline: "DMP XR550DEL-GCAN Dialer & Encrypted Network Panel in Large Gray Enclosure - Canada",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550del-gcan-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dl-g",
    manufacturer: "DMP",
    model: "XR150DL-G",
    category: "alarm-panel",
    tagline: "DMP XR150DL-G Dialer Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550depcb",
    manufacturer: "DMP",
    model: "XR550DEPCB",
    category: "alarm-panel",
    tagline: "DMP XR550DEPCB Dialer & Encrypted Network Panel, Board Only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550depcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550del-gz",
    manufacturer: "DMP",
    model: "XR550DEL-GZ",
    category: "alarm-panel",
    tagline: "DMP XR550DEL-GZ Dialer & Encrypted Network Panel in Large Gray Enclosure, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550del-gz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550npcb",
    manufacturer: "DMP",
    model: "XR550NPCB",
    category: "alarm-panel",
    tagline: "DMP XR550NPCB Network Panel, Board Only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550npcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550el-g",
    manufacturer: "DMP",
    model: "XR550EL-G",
    category: "alarm-panel",
    tagline: "DMP XR550EL-G Encrypted Network Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550el-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnpcbz",
    manufacturer: "DMP",
    model: "XR150DNPCBZ",
    category: "alarm-panel",
    tagline: "DMP XR150DNPCBZ Dialer Panel, PCB only, with network, no transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnpcbz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150nl-gcan",
    manufacturer: "DMP",
    model: "XR150NL-GCAN",
    category: "alarm-panel",
    tagline: "DMP XR150NL-GCAN Network Panel in Large Gray Enclosure - Canada",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150nl-gcan-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550nl-gz",
    manufacturer: "DMP",
    model: "XR550NL-GZ",
    category: "alarm-panel",
    tagline: "DMP XR550NL-GZ Network Panel in Large Gray Enclosure, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550nl-gz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150l-g",
    manufacturer: "DMP",
    model: "XR150L-G",
    category: "alarm-panel",
    tagline: "DMP XR150L-G panel in large gray enclosure, no communication",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150l-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550npcbz",
    manufacturer: "DMP",
    model: "XR550NPCBZ",
    category: "alarm-panel",
    tagline: "DMP XR550NPCBZ Network Panel, Board Only, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550npcbz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550nl-gcan",
    manufacturer: "DMP",
    model: "XR550NL-GCAN",
    category: "alarm-panel",
    tagline: "DMP XR550NL-GCAN Network Panel in Large Gray Enclosure - Canada",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550nl-gcan-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550ea-g",
    manufacturer: "DMP",
    model: "XR550EA-G",
    category: "alarm-panel",
    tagline: "DMP XR550EA-G Encrypted Network Panel in Large Attack Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550ea-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150nl-gz",
    manufacturer: "DMP",
    model: "XR150NL-GZ",
    category: "alarm-panel",
    tagline: "DMP XR150NL-GZ Network Panel in Large Gray Enclosure, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150nl-gz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnl-gz",
    manufacturer: "DMP",
    model: "XR150DNL-GZ",
    category: "alarm-panel",
    tagline: "DMP XR150DNL-GZ Dialer Panel, No transformer, with network",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnl-gz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550depcbz",
    manufacturer: "DMP",
    model: "XR550DEPCBZ",
    category: "alarm-panel",
    tagline: "DMP XR550DEPCBZ Dialer & Encrypted Network Panel, Board Only, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550depcbz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150npcb",
    manufacturer: "DMP",
    model: "XR150NPCB",
    category: "alarm-panel",
    tagline: "DMP XR150NPCB Network Panel, PCB only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150npcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dl-g",
    manufacturer: "DMP",
    model: "XR550DL-G",
    category: "alarm-panel",
    tagline: "DMP XR550DL-G Dialer Panel in Large Gray Enclosure",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dl-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr550dnpcbz",
    manufacturer: "DMP",
    model: "XR550DNPCBZ",
    category: "alarm-panel",
    tagline: "DMP XR550DNPCBZ Dialer & Network Panel, Board Only, No transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr550dnpcbz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":562,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dnl-gcan",
    manufacturer: "DMP",
    model: "XR150DNL-GCAN",
    category: "alarm-panel",
    tagline: "DMP XR150DNL-GCAN Dialer Panel, with network, Canada",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dnl-gcan-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dpcb",
    manufacturer: "DMP",
    model: "XR150DPCB",
    category: "alarm-panel",
    tagline: "DMP XR150DPCB Dialer Panel, PCB only",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dpcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150dl-r",
    manufacturer: "DMP",
    model: "XR150DL-R",
    category: "alarm-panel",
    tagline: "DMP XR150DL-R Dialer Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150dl-r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dmp-xr150pcb",
    manufacturer: "DMP",
    model: "XR150PCB",
    category: "alarm-panel",
    tagline: "DMP XR150PCB Panel PCB only, No Communication",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dmp-xr150pcb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"XR","zonesMax":130,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-60-806-95r-16z",
    manufacturer: "Concord",
    model: "60-806-95R-16Z",
    category: "alarm-panel",
    tagline: "Concord 60-806-95R-16Z Concord Express Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-806-95r-16z-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-983",
    manufacturer: "Concord",
    model: "60-983",
    category: "alarm-panel",
    tagline: "Concord 60-983 ATP 1000 alphanumeric touchpad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-983-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-820",
    manufacturer: "Concord",
    model: "60-820",
    category: "alarm-panel",
    tagline: "Concord 60-820 fixed display LCD touchpad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-820-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-783-02",
    manufacturer: "Concord",
    model: "60-783-02",
    category: "alarm-panel",
    tagline: "Concord 60-783-02 SuperBus 2000 automation module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-783-02-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1020",
    manufacturer: "Concord",
    model: "600-1020",
    category: "alarm-panel",
    tagline: "Concord 600-1020 FTP1000 fixed English touchpad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1020-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1023",
    manufacturer: "Concord",
    model: "600-1023",
    category: "alarm-panel",
    tagline: "Concord 600-1023 standard transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1023-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-770",
    manufacturer: "Concord",
    model: "60-770",
    category: "alarm-panel",
    tagline: "Concord 60-770 SuperBus 2000 4-output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-770-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-620-01",
    manufacturer: "Concord",
    model: "60-620-01",
    category: "alarm-panel",
    tagline: "Concord 60-620-01 Super Bus 2000 energy-saver module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-620-01-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-concord-600-822",
    manufacturer: "Concord",
    model: "600-822",
    category: "alarm-panel",
    tagline: "Concord 600-822 standard transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-822-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":24,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-60-777-01",
    manufacturer: "Concord",
    model: "60-777-01",
    category: "alarm-panel",
    tagline: "Concord 60-777-01 SuperBus 2000 phone interface and voice module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-777-01-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-985-60-984",
    manufacturer: "Concord",
    model: "60-985/60-984",
    category: "alarm-panel",
    tagline: "Concord 60-985/60-984 alphanumeric touchpads",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-985-60-984-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1025-01-95r",
    manufacturer: "Concord",
    model: "600-1025-01-95R",
    category: "alarm-panel",
    tagline: "Concord 600-1025-01-95R SuperBus 2000 transceiver module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1025-01-95r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-756",
    manufacturer: "Concord",
    model: "60-756",
    category: "alarm-panel",
    tagline: "Concord 60-597-95 combo input/outpu SnapCard",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-756-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-757",
    manufacturer: "Concord",
    model: "60-757",
    category: "alarm-panel",
    tagline: "Concord 60-757 8 zone hardwire input SnapCard",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-757-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1023-cn",
    manufacturer: "Concord",
    model: "600-1023-CN",
    category: "alarm-panel",
    tagline: "Concord 600-1023-CN 16.5 V, 40 VA standard transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1023-cn-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1024",
    manufacturer: "Concord",
    model: "600-1024",
    category: "alarm-panel",
    tagline: "Concord 600-1024 16.5 V, 40 VA power line carrier transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1024-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1053-3",
    manufacturer: "Concord",
    model: "600-1053-3",
    category: "alarm-panel",
    tagline: "Concord 600-1053-3 SuperBus 2000 GSM module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1053-3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-concord-60-804-04",
    manufacturer: "Concord",
    model: "60-804-04",
    category: "alarm-panel",
    tagline: "Concord 60-804-04 vaccum fluroescent display alphanumeric touchpad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-804-04-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-597-95",
    manufacturer: "Concord",
    model: "60-597-95",
    category: "alarm-panel",
    tagline: "Concord 60-597-95 HiTech handheld touchpad",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-597-95-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-822-cn",
    manufacturer: "Concord",
    model: "600-822-CN",
    category: "alarm-panel",
    tagline: "Concord 600-822-CN standard transformer",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-822-cn-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":24,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-60-821-95",
    manufacturer: "Concord",
    model: "60-821-95",
    category: "alarm-panel",
    tagline: "Concord 60-821-95 commerical transreciver module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-821-95-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-758",
    manufacturer: "Concord",
    model: "60-758",
    category: "alarm-panel",
    tagline: "Concord 60-758 4 output Snapcard",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-758-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-60-746-01-60-803-04",
    manufacturer: "Concord",
    model: "60-746-01/60-803-04",
    category: "alarm-panel",
    tagline: "Concord 60-746-01/60-803-04 alphanumeric touchpads",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-746-01-60-803-04-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-600-1053-4-zx-rg",
    manufacturer: "Concord",
    model: "600-1053-4-ZX-RG",
    category: "alarm-panel",
    tagline: "Concord 600-1053-4-ZX-RG GSM/GPRS cellular modem with Z-wave",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1053-4-zx-rg-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-concord-60-774",
    manufacturer: "Concord",
    model: "60-774",
    category: "alarm-panel",
    tagline: "Concord 60-774 SuperBus 2000 8 zone input module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-60-774-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-concord-concord-4",
    manufacturer: "Concord",
    model: "Concord 4",
    category: "alarm-panel",
    tagline: "Concord 4 hardwire/wireless modular security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-concord-4-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Concord","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-600-1053-4-zx-at",
    manufacturer: "Concord",
    model: "600-1053-4-ZX-AT",
    category: "alarm-panel",
    tagline: "Concord 600-1053-4-ZX-AT Wireless GSM/GPRS Cellular Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1053-4-zx-at-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-600-1053-4-zx-vz",
    manufacturer: "Concord",
    model: "600-1053-4-ZX-VZ",
    category: "alarm-panel",
    tagline: "Concord 600-1053-4-ZX-VZ Verizon CDMA Cellular Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1053-4-zx-vz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-600-1053-4-zx-tm",
    manufacturer: "Concord",
    model: "600-1053-4-ZX-TM",
    category: "alarm-panel",
    tagline: "Concord 600-1053-4-ZX-TM Wireless GSM/GPRS Cellular Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1053-4-zx-tm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-concord-600-1019",
    manufacturer: "Concord",
    model: "600-1019",
    category: "alarm-panel",
    tagline: "Concord 600-1019 2-Amp Power Supply",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/concord-600-1019-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-dahua-technology-arc9016c-v3",
    manufacturer: "Dahua Technology",
    model: "ARC9016C-V3",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC9016C-V3 alarm controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc9016c-v3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":1,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet"]},
  },
  {
    id: "ss-dahua-technology-arc2008c-v3",
    manufacturer: "Dahua Technology",
    model: "ARC2008C-V3",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC2008C-V3 alarm controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc2008c-v3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":1,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet"]},
  },
  {
    id: "ss-dahua-technology-arc3800h-w2",
    manufacturer: "Dahua Technology",
    model: "ARC3800H-W2",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3800H-W2 wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3800h-w2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc2016c-v3",
    manufacturer: "Dahua Technology",
    model: "ARC2016C-V3",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC2016C-V3 alarm controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc2016c-v3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":1,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet"]},
  },
  {
    id: "ss-dahua-technology-arc3800h-fw2",
    manufacturer: "Dahua Technology",
    model: "ARC3800H-FW2",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3800H-FW2 wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3800h-fw2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3800h-fw2-868",
    manufacturer: "Dahua Technology",
    model: "ARC3800H-FW2(868)",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3800H-FW2(868) wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3800h-fw2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3800h-w2-868",
    manufacturer: "Dahua Technology",
    model: "ARC3800H-W2(868)",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3800H-W2(868) wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3800h-w2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-fw2",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-FW2",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-FW2 wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-fw2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-gw2",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-GW2",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-GW2 wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-gw2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-w2",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-W2",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-W2 wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-w2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-w2-868",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-W2(868)",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-W2(868) wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-w2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-gw2-868",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-GW2(868)",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-GW2(868) wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-gw2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3000h-fw2-868",
    manufacturer: "Dahua Technology",
    model: "ARC3000H-FW2(868)",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3000H-FW2(868) wireless alarm hub",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3000h-fw2-868-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-dahua-technology-vta8311ab",
    manufacturer: "Dahua Technology",
    model: "VTA8311AB",
    category: "alarm-panel",
    tagline: "Dahua Technology VTA8311AB Wired & Wireless Alarm Column",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-vta8311ab-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VTA","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-vta8311a-4",
    manufacturer: "Dahua Technology",
    model: "VTA8311A-4",
    category: "alarm-panel",
    tagline: "Dahua Technology VTA8311A-4 Wired & Wireless Alarm Column",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-vta8311a-4-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VTA","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-dahua-technology-vta8311ab-4",
    manufacturer: "Dahua Technology",
    model: "VTA8311AB-4",
    category: "alarm-panel",
    tagline: "Dahua Technology VTA8311AB-4 Wired & Wireless Alarm Column",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-vta8311ab-4-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VTA","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-vta8311a",
    manufacturer: "Dahua Technology",
    model: "VTA8311A",
    category: "alarm-panel",
    tagline: "Dahua Technology VTA8311A Wired & Wireless Alarm Column",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-vta8311a-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VTA","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","wireless"]},
  },
  {
    id: "ss-dahua-technology-arc3008c",
    manufacturer: "Dahua Technology",
    model: "ARC3008C",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC3008C Security Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc3008c-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":11,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE"]},
  },
  {
    id: "ss-dahua-technology-arc9016c",
    manufacturer: "Dahua Technology",
    model: "ARC9016C",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC9016C Alarm Controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc9016c-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet"]},
  },
  {
    id: "ss-dahua-technology-arc2008c",
    manufacturer: "Dahua Technology",
    model: "ARC2008C",
    category: "alarm-panel",
    tagline: "Dahua Technology ARC2008C Alarm Controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/dahua-technology-arc2008c-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ARC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet"]},
  },
  {
    id: "ss-networx-nx-584",
    manufacturer: "NetworX",
    model: "NX-584",
    category: "alarm-panel",
    tagline: "NetworX NX-584 home automation interface module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-584-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-networx-nx-320e",
    manufacturer: "NetworX",
    model: "NX-320E",
    category: "alarm-panel",
    tagline: "NetworX NX-320E smart power supply and bus extender",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-320e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-networx-600-1023",
    manufacturer: "NetworX",
    model: "600-1023",
    category: "alarm-panel",
    tagline: "NetworX 600-1023 transformer, 16.5VAC, 40VA",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-600-1023-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-networx-nx-582e",
    manufacturer: "NetworX",
    model: "NX-582E",
    category: "alarm-panel",
    tagline: "NetworX NX-582E AES long-range radio interface module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-582e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-networx-nx-8",
    manufacturer: "NetworX",
    model: "NX-8",
    category: "alarm-panel",
    tagline: "NetworkX NX-8 Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networkx-nx-8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-networx-nx-4",
    manufacturer: "NetworX",
    model: "NX-4",
    category: "alarm-panel",
    tagline: "NetworX NX-4 Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-4-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-networx-networx-intruder-alarm-control-panel",
    manufacturer: "NetworX",
    model: "NetworX Intruder Alarm Control Panel",
    category: "alarm-panel",
    tagline: "NetworX security systems",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-networx-intruder-alarm-control-panel-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NetworX","zonesMax":192,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-networx-nx-8e",
    manufacturer: "NetworX",
    model: "NX-8E",
    category: "alarm-panel",
    tagline: "NetworkX NX-8E Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networkx-nx-8e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":192,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-networx-nx-592e-gsm-zx-tm",
    manufacturer: "NetworX",
    model: "NX-592E-GSM-ZX-TM",
    category: "alarm-panel",
    tagline: "NetworX NNX-592E-GSM-ZX-TM wireless cellular module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-gsm-zx-tm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-592e-cdma-zx-vz",
    manufacturer: "NetworX",
    model: "NX-592E-CDMA-ZX-VZ",
    category: "alarm-panel",
    tagline: "NetworX NX-592E-CDMA-ZX-VZ wireless cellular module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-cdma-zx-vz-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-6",
    manufacturer: "NetworX",
    model: "NX-6",
    category: "alarm-panel",
    tagline: "NetworX NX-6 Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-6-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":16,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-networx-nx-592e-gsm-zx-at",
    manufacturer: "NetworX",
    model: "NX-592E-GSM-ZX-AT",
    category: "alarm-panel",
    tagline: "NetworX NX-592E-GSM-ZX-AT wireless cellular module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-gsm-zx-at-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-592e-gsm-zx-rg",
    manufacturer: "NetworX",
    model: "NX-592E-GSM-ZX-RG",
    category: "alarm-panel",
    tagline: "NetworX NX-592E-GSM-ZX-RG wireless cellular module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-gsm-zx-rg-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-592e-gsm-at",
    manufacturer: "NetworX",
    model: "NX-592E-GSM-AT",
    category: "alarm-panel",
    tagline: "NetworX NX-592E-GSM-AT Wireless GSM/GPRS Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-gsm-at-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-networx-nx-591ne-gsm",
    manufacturer: "NetworX",
    model: "NX-591NE-GSM",
    category: "alarm-panel",
    tagline: "NetworX NX-591NE-GSM wireless cellular module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-591ne-gsm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-540e",
    manufacturer: "NetworX",
    model: "NX-540E",
    category: "alarm-panel",
    tagline: "NetworX NX-540E telephone interface module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-540e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-networx-nx-592e-gsm-zwave-at",
    manufacturer: "NetworX",
    model: "NX-592E-GSM-ZWAVE-AT",
    category: "alarm-panel",
    tagline: "NetworX NX-592E-GSM-ZWAVE-AT Wireless GSM/GPRS Modem",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-592e-gsm-zwave-at-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-networx-nx-590ne",
    manufacturer: "NetworX",
    model: "NX-590NE",
    category: "alarm-panel",
    tagline: "NetworX NX-590NE Ethernet-connected network module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-590ne-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-networx-nx-588e",
    manufacturer: "NetworX",
    model: "NX-588E",
    category: "alarm-panel",
    tagline: "NetworX NX-588E quik link direct connect module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/networx-nx-588e-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"NX-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-hikvision-ds-pa101-16p-wb",
    manufacturer: "Hikvision",
    model: "DS-PA101-16P-WB",
    category: "alarm-panel",
    tagline: "Hikvision AX HOME Series wireless alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pa101-16p-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hikvision AX HOME series","zonesMax":16,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pha64-kit-wb-b",
    manufacturer: "Hikvision",
    model: "DS-PHA64-Kit-WB(B)",
    category: "alarm-panel",
    tagline: "Hikvision AX Hybrid PRO Alarm System For SMB Industrial Facilities",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pha64-kit-wb-b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PHA","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa64-kit-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA64-Kit-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA64-Kit-WB wireless intrusion alarm system - AX PRO Kit (433MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa64-kit-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa64-l-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA64-L-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA64-L-WB wireless intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa64-l-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-m-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-M-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-M-WE wireless intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-m-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa64-l-we",
    manufacturer: "Hikvision",
    model: "DS-PWA64-L-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA64-L-WE wireless intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa64-l-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-kit-we",
    manufacturer: "Hikvision",
    model: "DS-PWA96-Kit-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-Kit-WE AX PRO Kit (868MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-kit-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-kit-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA96-Kit-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-Kit-WB wireless intrusion alarm system - AX PRO Kit (433MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-kit-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa64-kit-we",
    manufacturer: "Hikvision",
    model: "DS-PWA64-Kit-WE",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA64-Kit-WE AX PRO Kit (868MHz)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa64-kit-we-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":64,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa96-m-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA96-M-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA96-M-WB wireless intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa96-m-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"AX PRO series","zonesMax":96,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-hikvision-ds-pwa48-e-wb",
    manufacturer: "Hikvision",
    model: "DS-PWA48-E-WB",
    category: "alarm-panel",
    tagline: "Hikvision DS-PWA48-E-WB AX PRO (433MHz) Wireless Intrusion Alarm",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pwa48-e-wb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PWA","zonesMax":48,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-hikvision-ds-pha48-ep-b",
    manufacturer: "Hikvision",
    model: "DS-PHA48-EP(B)",
    category: "alarm-panel",
    tagline: "Hikvision DS-PHA48-EP(B) AX Hybrid Pro Wired Intrusion Alarm",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/hikvision-ds-pha48-ep-b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"DS-PHA","zonesMax":8,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-napco-wizard-ii",
    manufacturer: "NAPCO",
    model: "WIZARD II",
    category: "alarm-panel",
    tagline: "NAPCO WIZARD II voice phone module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/napco-wizard-ii-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"WIZARD","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-napco-gem-eva",
    manufacturer: "NAPCO",
    model: "GEM-EVA",
    category: "alarm-panel",
    tagline: "NAPCO GEM-EVA electronic voice annunciator",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/napco-gem-eva-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"GEM-EVA","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-napco-wizard-iie",
    manufacturer: "NAPCO",
    model: "WIZARD IIE",
    category: "alarm-panel",
    tagline: "NAPCO WIZARD IIE voice phone module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/napco-wizard-iie-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"WIZARD","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-napco-gem-p9600m",
    manufacturer: "NAPCO",
    model: "GEM-P9600M",
    category: "alarm-panel",
    tagline: "NAPCO GEM-P9600M hybrid intruder alarm control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/napco-gem-p9600m-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Gemini Series","zonesMax":8,"zonesOnboard":0,"partitions":8,"grade":2,"users":96,"communicators":["wireless"]},
  },
  {
    id: "ss-pyronix-replacement-battery-for-enforcer",
    manufacturer: "Pyronix",
    model: "Replacement Battery for Enforcer",
    category: "alarm-panel",
    tagline: "Pyronix Replacement battery for Enforcer control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-replacement-battery-for-enforcer-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Replacement","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-pyronix-enforcer-64",
    manufacturer: "Pyronix",
    model: "Enforcer 64",
    category: "alarm-panel",
    tagline: "Pyronix Enforcer 64 featuring V12.5 firmware",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-enforcer-64-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Enforcer","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-pyronix-euro-mini-prox",
    manufacturer: "Pyronix",
    model: "EURO Mini Prox",
    category: "alarm-panel",
    tagline: "Pyronix EURO Mini Prox 2-way UR2-WE wireless entry level panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-euro-mini-prox-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"EURO","zonesMax":0,"zonesOnboard":0,"partitions":4,"grade":2,"users":30,"communicators":["wireless"],"outputsMax":4},
  },
  {
    id: "ss-pyronix-pcx-46",
    manufacturer: "Pyronix",
    model: "PCX 46",
    category: "alarm-panel",
    tagline: "PCX 46 APP: The ultimate hybrid security solution from Pyronix",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-pcx-46-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PCX","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"],"outputsMax":50},
  },
  {
    id: "ss-pyronix-enforcer-32-we-app",
    manufacturer: "Pyronix",
    model: "ENFORCER 32-WE APP",
    category: "alarm-panel",
    tagline: "Pyronix presents the Enforcer 32WE APP",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-enforcer-32-we-app-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ENFORCER","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-pyronix-pcx-78",
    manufacturer: "Pyronix",
    model: "PCX 78",
    category: "alarm-panel",
    tagline: "Pyronix PCX 78 PCX hybrid control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-pcx-78-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PCX","zonesMax":78,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-pyronix-pcx-46-app",
    manufacturer: "Pyronix",
    model: "PCX 46 APP",
    category: "alarm-panel",
    tagline: "Pyronix PCX46 APP: The ultimate IP security solution for any industrial or commercial installation",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/pyronix-pcx-46-app-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"PCX","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"],"outputsMax":50},
  },
  {
    id: "ss-ajax-starterkit-plus",
    manufacturer: "Ajax",
    model: "StarterKit Plus",
    category: "alarm-panel",
    tagline: "Ajax StarterKit Plus",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-starterkit-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"StarterKit","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-ajax-hub-2-plus",
    manufacturer: "Ajax",
    model: "Hub 2 Plus",
    category: "alarm-panel",
    tagline: "Ajax Hub 2 Plus security system control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-2-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":200,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-ajax-hub-hybrid-4g",
    manufacturer: "Ajax",
    model: "Hub Hybrid (4G)",
    category: "alarm-panel",
    tagline: "Ajax Hub Hybrid (4G) - Hybrid security system control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-hybrid-4g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-ajax-hub-2-4g",
    manufacturer: "Ajax",
    model: "Hub 2 (4G)",
    category: "alarm-panel",
    tagline: "Ajax Hub 2 (4G) security system control panel with support for photo verification",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-2-4g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-ajax-hub-2-2g",
    manufacturer: "Ajax",
    model: "Hub 2 (2G)",
    category: "alarm-panel",
    tagline: "Ajax Hub 2 (2G) security system control panel with support for photo verification",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-2-2g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-ajax-hub-hybrid-2g",
    manufacturer: "Ajax",
    model: "Hub Hybrid (2G)",
    category: "alarm-panel",
    tagline: "Ajax Hub Hybrid (2G) - Hybrid security system control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-hybrid-2g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":5,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-ajax-hub",
    manufacturer: "Ajax",
    model: "Hub",
    category: "alarm-panel",
    tagline: "Ajax Hub security system control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-ajax-uartbridge",
    manufacturer: "Ajax",
    model: "uartBridge",
    category: "alarm-panel",
    tagline: "Ajax uartBridge module for integrating Ajax detectors into third-party wireless security systems and",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-uartbridge-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"uartBridge","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-ajax-hub-plus",
    manufacturer: "Ajax",
    model: "Hub Plus",
    category: "alarm-panel",
    tagline: "Ajax Hub Plus security system control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":150,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE"]},
  },
  {
    id: "ss-ajax-ocbridge-plus",
    manufacturer: "Ajax",
    model: "ocBridge Plus",
    category: "alarm-panel",
    tagline: "Ajax ocBridge Plus module for integrating Ajax devices to wired and hybrid security systems",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-ocbridge-plus-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ocBridge","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-ajax-hub-2",
    manufacturer: "Ajax",
    model: "Hub 2",
    category: "alarm-panel",
    tagline: "Ajax Hub 2 security control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/ajax-hub-2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hub","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-verex-monitor-xl-door-controllers",
    manufacturer: "Verex",
    model: "Monitor XL Door Controllers",
    category: "alarm-panel",
    tagline: "Verex Monitor XL Door Controllers with magnetic lock bond sense",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verex-monitor-xl-door-controllers-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Verex series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-verkada-professional-monitoring",
    manufacturer: "Verkada",
    model: "Professional Monitoring",
    category: "alarm-panel",
    tagline: "Verkada Monitored Alarm System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-professional-monitoring-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Professional","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-verkada-acc-con-std-1",
    manufacturer: "Verkada",
    model: "ACC-CON-STD-1",
    category: "alarm-panel",
    tagline: "Verkada ACC-CON-STD-1 Table Top Mounting Stand",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-acc-con-std-1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ACC-CON-STD-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-verkada-bc51-hw",
    manufacturer: "Verkada",
    model: "BC51-HW",
    category: "alarm-panel",
    tagline: "Verkada BC51-HW alarm console",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bc51-hw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BC","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-verkada-bp32-hw-na",
    manufacturer: "Verkada",
    model: "BP32-HW-NA",
    category: "alarm-panel",
    tagline: "Verkada BP32-HW-NA Wireless Alarm Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bp32-hw-na-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BP","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-verkada-bp52",
    manufacturer: "Verkada",
    model: "BP52",
    category: "alarm-panel",
    tagline: "Verkada BP52 Alarm Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bp52-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BP","zonesMax":32,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-verkada-bc82-hw",
    manufacturer: "Verkada",
    model: "BC82-HW",
    category: "alarm-panel",
    tagline: "Verkada BC82-HW Alarm Console",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bc82-hw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BC","zonesMax":60,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-verkada-bp41-hw",
    manufacturer: "Verkada",
    model: "BP41-HW",
    category: "alarm-panel",
    tagline: "Verkada BP41-HW alarm panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/verkada-bp41-hw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BP","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-truportal-tp-rdr-100a",
    manufacturer: "TruPortal",
    model: "TP-RDR-100A",
    category: "alarm-panel",
    tagline: "TruPortal TP-RDR-100A T-100 Series Reader",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truportal-tp-rdr-100a-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"TP-RDR-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-truportal-tp-rdr-200a",
    manufacturer: "TruPortal",
    model: "TP-RDR-200A",
    category: "alarm-panel",
    tagline: "TruPortal TP-RDR-200A T-200 Series Reader",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truportal-tp-rdr-200a-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"TP-RDR-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-truportal-tp-sys-brd",
    manufacturer: "TruPortal",
    model: "TP-SYS-BRD",
    category: "alarm-panel",
    tagline: "TruPortal TP-SYS-BRD System Controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truportal-tp-sys-brd-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"TP-SYS-BRD","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-truportal-tp-sys-2d",
    manufacturer: "TruPortal",
    model: "TP-SYS-2D",
    category: "alarm-panel",
    tagline: "TruPortal TP-SYS-2D 2-Door Base System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truportal-tp-sys-2d-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"TP-SYS-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-truportal-tp-sys-2d2r",
    manufacturer: "TruPortal",
    model: "TP-SYS-2D2R",
    category: "alarm-panel",
    tagline: "TruPortal TP-SYS-2D2R 2-Door Base System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/truportal-tp-sys-2d2r-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"TP-SYS-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-simon-xt-xti-80-632-3n-xti",
    manufacturer: "Simon XT/XTi",
    model: "80-632-3n-Xti",
    category: "alarm-panel",
    tagline: "Simon XTi 80-632-3n-Xti wireless security system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/simon-xt-xti-80-632-3n-xti-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-simon-xt-xti-two-way-talking-touch-screen",
    manufacturer: "Simon XT/XTi",
    model: "Two-Way Talking Touch Screen",
    category: "alarm-panel",
    tagline: "Simon XT Two-Way Talking Touch Screen",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/simon-xt-xti-two-way-talking-touch-screen-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Two-Way","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-simon-xt-xti-60-924-rf-ts-n",
    manufacturer: "Simon XT/XTi",
    model: "60-924-RF-TS-N",
    category: "alarm-panel",
    tagline: "Simon XT/XTi 60-924-RF-TS-N Two-Way Talking Touch Screen",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/simon-xt-xti-60-924-rf-ts-n-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-simon-xt-xti-80-632-3n-xt",
    manufacturer: "Simon XT/XTi",
    model: "80-632-3N-XT",
    category: "alarm-panel",
    tagline: "Simon XT/XTi 80-632-3N-XT Wireless Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/simon-xt-xti-80-632-3n-xt-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-senstar-f4kt0200",
    manufacturer: "Senstar",
    model: "F4KT0200",
    category: "alarm-panel",
    tagline: "Senstar F4KT0200 detection zone kit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-f4kt0200-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"F","zonesMax":200,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-senstar-00em1400",
    manufacturer: "Senstar",
    model: "00EM1400",
    category: "alarm-panel",
    tagline: "Senstar 00EM1400 processor module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-00em1400-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-senstar-00ma0100",
    manufacturer: "Senstar",
    model: "00MA0100",
    category: "alarm-panel",
    tagline: "Senstar 00MA0100 swing-out DIN rail",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-00ma0100-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-senstar-00em1600",
    manufacturer: "Senstar",
    model: "00EM1600",
    category: "alarm-panel",
    tagline: "Senstar 00EM1600 relay module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-00em1600-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-senstar-00em1500",
    manufacturer: "Senstar",
    model: "00EM1500",
    category: "alarm-panel",
    tagline: "Senstar 00EM1500 dry-contact input module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-00em1500-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-senstar-00em1700",
    manufacturer: "Senstar",
    model: "00EM1700",
    category: "alarm-panel",
    tagline: "Senstar 00EM1700 open-collector output module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/senstar-00em1700-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Series","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-gallagher-intruder-alarm-monitoring-and-control",
    manufacturer: "Gallagher",
    model: "Intruder Alarm Monitoring and Control",
    category: "alarm-panel",
    tagline: "Gallagher Intruder alarm monitoring and control system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gallagher-intruder-alarm-monitoring-and-control-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Intruder","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-gallagher-alarms-management",
    manufacturer: "Gallagher",
    model: "Alarms management",
    category: "alarm-panel",
    tagline: "Gallagher Alarms management",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gallagher-alarms-management-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Alarms","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-gallagher-t20-alarms-terminal",
    manufacturer: "Gallagher",
    model: "T20 Alarms Terminal",
    category: "alarm-panel",
    tagline: "Gallagher T20 Alarms Terminal for site wide alarms management",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gallagher-t20-alarms-terminal-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"T","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-gallagher-class-5-intruder-alarm-system-ias",
    manufacturer: "Gallagher",
    model: "Class 5 Intruder Alarm System (IAS)",
    category: "alarm-panel",
    tagline: "Gallagher Class 5 Intruder Alarm System (IAS)",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/gallagher-class-5-intruder-alarm-system-ias-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Class","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw",
    manufacturer: "Climax Technology",
    model: "HSGW",
    category: "alarm-panel",
    tagline: "Climax HSGW-G Home Security Gateway Series",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hsgw-gen3",
    manufacturer: "Climax Technology",
    model: "HSGW-Gen3",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-Gen3 Modular Smart Security Gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-gen3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-Gen","zonesMax":400,"zonesOnboard":0,"partitions":8,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-mz-series",
    manufacturer: "Climax Technology",
    model: "MZ Series",
    category: "alarm-panel",
    tagline: "Climax MZ Series brings smart security to your home",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mz-series-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Vesta Family","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-security-alarm",
    manufacturer: "Climax Technology",
    model: "Hybrid Security Alarm",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Security Alarm System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-security-alarm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":80,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel-lite",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel Lite",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Panel Lite wire and wireless smart home security gateway with LTE capabilit",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-lite-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":80,"zonesOnboard":0,"partitions":8,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-ctc-2716",
    manufacturer: "Climax Technology",
    model: "CTC-2716",
    category: "alarm-panel",
    tagline: "Climax offers GSM Alarm Panel CTC-2716 as an economic solution for the smartphone generation to expe",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ctc-2716-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"CTC Series","zonesMax":30,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-vl-series",
    manufacturer: "Climax Technology",
    model: "VL Series",
    category: "alarm-panel",
    tagline: "Climax Technology VL Touch Screen Smart Security System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-vl-series-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"VL","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel-1-ac110-240v",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel-1-AC110/240V",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Panel-1-AC110/240V IP-based smart home security gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-1-ac110-240v-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel-3-23-45-ac110-240v",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel-3-23/45-AC110/240V",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Panel-3-23/45-AC110/240V IP-based smart home security gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-3-23-45-ac110-240v-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mz-8",
    manufacturer: "Climax Technology",
    model: "MZ-8",
    category: "alarm-panel",
    tagline: "Climax Technology MZ-8 intrusion alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mz-8-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MZ Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel-1-ac16-18v",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel-1-AC16/18V",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Panel-1-AC16/18V IP-based smart home security gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-1-ac16-18v-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel-3-23-45-ac16-18v",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel-3-23/45-AC16/18V",
    category: "alarm-panel",
    tagline: "Climax Technology Hybrid Panel-3-23/45-AC16/18V IP-based smart home security gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-3-23-45-ac16-18v-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-ctc-2715",
    manufacturer: "Climax Technology",
    model: "CTC-2715",
    category: "alarm-panel",
    tagline: "Climax Technology CTC-2715 GSM alarm panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ctc-2715-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"CTC-","zonesMax":30,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mz-3",
    manufacturer: "Climax Technology",
    model: "MZ-3",
    category: "alarm-panel",
    tagline: "Climax Technology MZ-3 wireless GSM/GPRS control panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mz-3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MZ Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-bogp-3-4g-f1",
    manufacturer: "Climax Technology",
    model: "BOGP-3-4G-F1",
    category: "alarm-panel",
    tagline: "Climax Technology BOGP-3-4G-F1 battery-operated cellular alarm system with LTE/3G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-bogp-3-4g-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BOGP-3 Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-3-qt-dt35b",
    manufacturer: "Climax Technology",
    model: "MX-3-QT-DT35B",
    category: "alarm-panel",
    tagline: "Climax Technology MX-3-QT-DT35B Medical and Intrusion Alarm System with LTE/3G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-3-qt-dt35b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX-DT-35B Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-8-qt-dt35b",
    manufacturer: "Climax Technology",
    model: "MX-8-QT-DT35B",
    category: "alarm-panel",
    tagline: "Climax Technology MX-8-QT-DT35B Medical and Intrusion Alarm System with Ethernet/LTE/3G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-8-qt-dt35b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX-DT-35B Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw",
    manufacturer: "Climax Technology",
    model: "HPGW",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW home passport gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW","zonesMax":80,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-bogp-3-2g-f1",
    manufacturer: "Climax Technology",
    model: "BOGP-3-2G-F1",
    category: "alarm-panel",
    tagline: "Climax Technology BOGP-3-2G-F1 battery-operated cellular alarm system with 2G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-bogp-3-2g-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"BOGP-3 Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-g",
    manufacturer: "Climax Technology",
    model: "HPGW-G",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-G Smart Home Alarm System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-g-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-G","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-8-f1",
    manufacturer: "Climax Technology",
    model: "MX-8-F1",
    category: "alarm-panel",
    tagline: "Climax Technology MX-8-F1 Medical and Intrusion Alarm System with Ethernet/LTE/3G/GSM reporting and ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-8-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX Medical and Intrusion Alarm Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-3-f1",
    manufacturer: "Climax Technology",
    model: "MX-3-F1",
    category: "alarm-panel",
    tagline: "Climax Technology MX-3-F1 Medical And Intrusion Alarm System With LTE/3G/GSM Reporting And Compatibl",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-3-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX Medical and Intrusion Alarm Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-3-resa-dt8-f1868-zbs-6b",
    manufacturer: "Climax Technology",
    model: "HMGW-3-RESA-DT8-F1868-ZBS-6B",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-3-RESA-DT8-F1868-ZBS-6B IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-3-resa-dt8-f1868-zbs-6b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-8-qt-ex-dt35b",
    manufacturer: "Climax Technology",
    model: "MX-8-QT-EX-DT35B",
    category: "alarm-panel",
    tagline: "Climax Technology MX-8-QT-EX-DT35B medical and intrusion alarm system with Ethernet/LTE/3G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-8-qt-ex-dt35b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX-DT-35B Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-max1",
    manufacturer: "Climax Technology",
    model: "HPGW-MAX1",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-MAX1 IP alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-max1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-2-f1",
    manufacturer: "Climax Technology",
    model: "MX-2-F1",
    category: "alarm-panel",
    tagline: "Climax Technology MX-2-F1 Medical and Intrusion Alarm System with PSTN reporting and compatible with",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-medical-and-intrusion-alarm-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX Medical and Intrusion Alarm Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-15-dt8-zbs-zw",
    manufacturer: "Climax Technology",
    model: "HMGW-15-DT8-ZBS-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-15-DT8-ZBS-ZW IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-15-dt8-zbs-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-6-f1",
    manufacturer: "Climax Technology",
    model: "MX-6-F1",
    category: "alarm-panel",
    tagline: "Climax Technology MX-6-F1 Medical and Intrusion Alarm System with Ethernet/PSTN reporting and compat",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-6-f1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX Medical and Intrusion Alarm Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-max3",
    manufacturer: "Climax Technology",
    model: "HPGW-MAX3",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-MAX3 IP alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-max3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-1-dt8-zw",
    manufacturer: "Climax Technology",
    model: "HMGW-1-DT8-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-1-DT8-ZW IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-1-dt8-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-3-resa-dt8-f1868-f1433-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-3-RESA-DT8-F1868/F1433-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-3-RESA-DT8-F1868/F1433-ZBS IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-3-resa-dt8-f1868-f1433-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mx-3-qt-ex-dt35b",
    manufacturer: "Climax Technology",
    model: "MX-3-QT-EX-DT35B",
    category: "alarm-panel",
    tagline: "Climax Technology MX-3-QT-EX-DT35B medical and intrusion alarm system with LTE/3G reporting",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mx-3-qt-ex-dt35b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"MX-DT-35B Series","zonesMax":40,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-max1d",
    manufacturer: "Climax Technology",
    model: "HPGW-MAX1D",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-MAX1D IP alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-max1d-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-max2",
    manufacturer: "Climax Technology",
    model: "HPGW-MAX2",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-MAX2 IP alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-max2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hpgw-max5",
    manufacturer: "Climax Technology",
    model: "HPGW-MAX5",
    category: "alarm-panel",
    tagline: "Climax Technology HPGW-MAX5 IP alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hpgw-max5-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HPGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-ml-1-tp",
    manufacturer: "Climax Technology",
    model: "ML-1 TP",
    category: "alarm-panel",
    tagline: "Climax Technology ML-1 TP IP Based, Touch-Screen Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-1-tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-ml-8-tp",
    manufacturer: "Climax Technology",
    model: "ML-8 TP",
    category: "alarm-panel",
    tagline: "Climax Technology ML-8 TP 3G + GPRS + IP, Touch-Screen Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-8-tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-ml-3-tp",
    manufacturer: "Climax Technology",
    model: "ML-3 TP",
    category: "alarm-panel",
    tagline: "Climax Technology ML-3 TP 3G + GPRS, Touch-Screen Control Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-3-tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-max15-dt8-zbs-zw",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX15-DT8-ZBS-ZW",
    category: "alarm-panel",
    tagline: "Climax HMGW-MAX15-DT8-ZBS-ZW IP Gateway with built-in ZigBee and Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max15-dt8-zbs-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-max3-dt8-868-f1868-f1433-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX3-DT8-868/F1868/F1433-ZBS",
    category: "alarm-panel",
    tagline: "Climax HMGW-MAX3-DT8-868/F1868/F1433-ZBS IP-based alarm system with built-in F1 RF and ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max3-dt8-868-f1868-f1433-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hsgw-max8-dt32",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX8-DT32",
    category: "alarm-panel",
    tagline: "Climax HSGW-MAX8-DT32 WiFi, IP-based multi-functional RF and Z-Wave smart home security gateway",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max8-dt32-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-ml",
    manufacturer: "Climax Technology",
    model: "ML",
    category: "alarm-panel",
    tagline: "Climax Technology ML Smart Security Gateway Series",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ml-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN","Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-gx-cubic2",
    manufacturer: "Climax Technology",
    model: "GX-Cubic2",
    category: "alarm-panel",
    tagline: "Climax Technology GX-Cubic2 Smart Care Medical Alarm Solution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-gx-cubic2-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"GX-Cubic","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-gx-cubic3",
    manufacturer: "Climax Technology",
    model: "GX-Cubic3",
    category: "alarm-panel",
    tagline: "Climax Technology GX-Cubic3 Smart Care Medical Alarm Solution",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-gx-cubic3-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"GX-Cubic","zonesMax":100,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-1-dt8-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-1-DT8-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-1-DT8-ZBS IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-1-dt8-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-3-dt8-868-f1868-f1433-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-3-DT8-868/F1868/F1433-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-3-DT8-868/F1868/F1433-ZBS IP-based alarm system",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-3-dt8-868-f1868-f1433-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mlt-8-tp",
    manufacturer: "Climax Technology",
    model: "MLT-8 TP",
    category: "alarm-panel",
    tagline: "Climax Technology MLT-8 TP 3G + GPRS + IP, Touch-Screen Control Panel with Tag Reader",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mlt-8-tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-mlt-3tp",
    manufacturer: "Climax Technology",
    model: "MLT-3TP",
    category: "alarm-panel",
    tagline: "Climax Technology MLT-3TP 3G + GPRS, Touch-Screen Control Panel with Tag Reader",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mlt-3tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-mlt-1tp",
    manufacturer: "Climax Technology",
    model: "MLT-1TP",
    category: "alarm-panel",
    tagline: "Climax Technology MLT-1TP IP Based, Touch-Screen Control Panel with Tag Reader",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mlt-1tp-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ML Series","zonesMax":50,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-max3-resa-dt8-f1868-zbs-6b",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX3-RESA-DT8-F1868-ZBS-6B",
    category: "alarm-panel",
    tagline: "Climax HMGW-MAX3-RESA-DT8-F1868-ZBS-6B IP-based alarm system with built-in F1 RF and ZigBee module, ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max3-resa-dt8-f1868-zbs-6b-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-max3-resa-dt8-f1868-f1433-zbs",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX3-RESA-DT8-F1868/F1433-ZBS",
    category: "alarm-panel",
    tagline: "Climax HMGW-MAX3-RESA-DT8-F1868/F1433-ZBS IP-based alarm system with built-in F1 RF and ZigBee modul",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max3-resa-dt8-f1868-f1433-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hmgw-max1-dt8-zw",
    manufacturer: "Climax Technology",
    model: "HMGW-MAX1-DT8-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW-MAX1-DT8-ZW IP-based alarm system with built-in Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-max1-dt8-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW-MAX Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["wireless"]},
  },
  {
    id: "ss-climax-technology-hsvgw-g-series",
    manufacturer: "Climax Technology",
    model: "HSVGW-G Series",
    category: "alarm-panel",
    tagline: "Climax Technology HSVGW-G Home Security Voice Gateway Series",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsvgw-g-series-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSVGW-G","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
  {
    id: "ss-climax-technology-hsgw-max5-zbs-zw-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX5-ZBS-ZW-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX5-ZBS-ZW-WIFI IP Gateway with built-in ZigBee, Z-Wave module, and WiFi con",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max5-zbs-zw-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max15-zbs-zw-sf1",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX15-ZBS-ZW-SF1",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX15-ZBS-ZW-SF1 IP Gateway with built-in RF, ZigBee, and Z-Wave modules",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max15-zbs-zw-sf1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max3-sf1-zw-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX3-SF1-ZW-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX3-SF1-ZW-WIFI IP Gateway with built-in RF, Z-Wave module and WiFi connecti",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max3-sf1-zw-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max3-sf1-zw",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX3-SF1-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX3-SF1-ZW IP Gateway with built-in RF, and Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max3-sf1-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-rc-15",
    manufacturer: "Climax Technology",
    model: "RC-15",
    category: "alarm-panel",
    tagline: "Climax Technology RC-15 water resistant remote controller with IP rating 41",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-rc-15-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Vesta Family","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max8-lte-zw-sf1-sfv",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX8-LTE-ZW-SF1-(SFV)",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX8-LTE-ZW-SF1-(SFV) IP Gateway with built-in RF, LTE, and Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max8-lte-zw-sf1-sfv-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-hsgw-max8-lte-zbs-sf1-sfv",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX8-LTE-ZBS-SF1-(SFV)",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX8-LTE-ZBS-SF1-(SFV) IP Gateway with built-in RF, LTE, and ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max8-lte-zbs-sf1-sfv-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-hsgw-max5-zbs-zw",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX5-ZBS-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX5-ZBS-ZW IP Gateway with built-in ZigBee, and Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max5-zbs-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max3-sf1-zbs-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX3-SF1-ZBS-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX3-SF1-ZBS-WIFI IP Gateway with built-in RF, ZigBee module and WiFi connect",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max3-sf1-zbs-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max1-zw-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-ZW-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-ZW-WIFI IP Gateway with built-in Z-Wave and WIFI connections",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-zw-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max15-zbs-zw-sf1-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX15-ZBS-ZW-SF1-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX15-ZBS-ZW-SF1-WIFI IP Gateway with built-in RF, ZigBee, Z-Wave modules and",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max15-zbs-zw-sf1-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max8-ex-lte-zbs-sf1-sfv",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX8-EX-LTE-ZBS-SF1-(SFV)",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX8-EX-LTE-ZBS-SF1-(SFV) IP Gateway with built-in RF, LTE, and ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max8-ex-lte-zbs-sf1-sfv-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-hsgw-max3-sf1-zbs",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX3-SF1-ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX3-SF1-ZBS IP Gateway with built-in RF and ZigBee module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max3-sf1-zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max1-zw",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-ZW",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-ZW IP Gateway with built-in Z-Wave module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max1-zbs-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-ZBS-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-ZBS-WIFI IP Gateway with built-in ZigBee and WIFI connections",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-zbs-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max1-sf1-wifi",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-SF1-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-SF1-WIFI IP Gateway with built-in RF and WIFI connections",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-sf1-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hsgw-max1-sf1",
    manufacturer: "Climax Technology",
    model: "HSGW-MAX1-SF1",
    category: "alarm-panel",
    tagline: "Climax Technology HSGW-MAX1-SF1 multi-functional smart home security gateway with built-in RF module",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hsgw-max1-sf1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HSGW-MAX","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-rc-15zb",
    manufacturer: "Climax Technology",
    model: "RC-15ZB",
    category: "alarm-panel",
    tagline: "Climax Technology RC-15ZB ZigBee remote controller",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-rc-15zb-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"RC-","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-15-wifi",
    manufacturer: "Climax Technology",
    model: "ESGW-15-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-15-WIFI with 24-hour emergency monitoring and visual verification solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-15-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-esgw-15",
    manufacturer: "Climax Technology",
    model: "ESGW-15",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-15 with 24-hour emergency monitoring and visual verification solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-15-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-esgw-1zbs",
    manufacturer: "Climax Technology",
    model: "ESGW-1ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-1ZBS with 24-hour emergency monitoring and visual verification solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-1zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-x1",
    manufacturer: "Climax Technology",
    model: "X1",
    category: "alarm-panel",
    tagline: "Climax X1 Alexa Built-in Alarm System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-x1-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"X","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-18zbs-wifi",
    manufacturer: "Climax Technology",
    model: "ESGW-18ZBS-WIFI",
    category: "alarm-panel",
    tagline: "Climax ESGW-18ZBS-WIFI IP gateway with a built-in RF, ZigBee module, Wi-Fi connections, and recharge",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-18zbs-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-series",
    manufacturer: "Climax Technology",
    model: "ESGW Series",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW Easy Security Gateway Series Smart Home Alarm Systems",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-series-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-esgw-1zw",
    manufacturer: "Climax Technology",
    model: "ESGW-1ZW",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-1ZW with 24-hour emergency monitoring and visual verification solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-1zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-esgw-1zbs-wifi",
    manufacturer: "Climax Technology",
    model: "ESGW-1ZBS-WIFI",
    category: "alarm-panel",
    tagline: "Climax ESGW-1ZBS-WIFI IP gateway with a built-in ZigBee module and Wi-Fi capabilities, without batte",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-1zbs-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-15zw",
    manufacturer: "Climax Technology",
    model: "ESGW-15ZW",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-15ZW IP gateway with a built-in RF, Z-Wave module, and rechargeable battery p",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-15zw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-1zw-wifi",
    manufacturer: "Climax Technology",
    model: "ESGW-1ZW-WIFI",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-1ZW-WIFI with 24-hour emergency monitoring and visual verification solutions",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-1zw-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-esgw-18zw-wifi",
    manufacturer: "Climax Technology",
    model: "ESGW-18ZW-WIFI",
    category: "alarm-panel",
    tagline: "Climax ESGW-18ZW-WIFI IP gateway with a built-in RF, Z-Wave module, Wi-Fi connections, and rechargea",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-18zw-wifi-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-esgw-15zbs",
    manufacturer: "Climax Technology",
    model: "ESGW-15ZBS",
    category: "alarm-panel",
    tagline: "Climax Technology ESGW-15ZBS IP gateway with a built-in RF, ZigBee module, and rechargeable battery ",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-esgw-15zbs-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"ESGW Series","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-ctc-1041rv",
    manufacturer: "Climax Technology",
    model: "CTC-1041RV",
    category: "alarm-panel",
    tagline: "Climax Technology CTC-1041RV PSTN Medical Alarm with DECT",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ctc-1041rv-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"CTC-","zonesMax":10,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["PSTN"]},
  },
  {
    id: "ss-climax-technology-ctc-1052c",
    manufacturer: "Climax Technology",
    model: "CTC-1052C",
    category: "alarm-panel",
    tagline: "Climax Technology CTC-1052C 4G Medical Alarm Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ctc-1052c-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"CTC-","zonesMax":10,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-ctc-1052",
    manufacturer: "Climax Technology",
    model: "CTC-1052",
    category: "alarm-panel",
    tagline: "Climax Technology CTC-1052 4G Medical Alarm Panel",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-ctc-1052-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"CTC-","zonesMax":2,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["GSM-LTE"]},
  },
  {
    id: "ss-climax-technology-mobile-pro-i",
    manufacturer: "Climax Technology",
    model: "Mobile Pro I",
    category: "alarm-panel",
    tagline: "Climax Technology Mobile Pro I Enhanced Smart Care System",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mobile-pro-i-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Mobile","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2},
  },
  {
    id: "ss-climax-technology-hmgw",
    manufacturer: "Climax Technology",
    model: "HMGW",
    category: "alarm-panel",
    tagline: "Climax Technology HMGW IP-based alarm system with RF/ZigBee/Z-Wave and optional Wi-Fi capabilities",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hmgw-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"HMGW","zonesMax":160,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet","wireless"]},
  },
  {
    id: "ss-climax-technology-mobile-lite",
    manufacturer: "Climax Technology",
    model: "Mobile Lite",
    category: "alarm-panel",
    tagline: "Climax Technology Mobile Lite 4G PERS with GPS location tracking",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-mobile-lite-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Mobile","zonesMax":0,"zonesOnboard":0,"partitions":1,"grade":2,"communicators":["Ethernet"]},
  },
  {
    id: "ss-climax-technology-hybrid-panel",
    manufacturer: "Climax Technology",
    model: "Hybrid Panel",
    category: "alarm-panel",
    tagline: "A complete wired security system offered by Climax",
    verified: false,
    datasheetUrl: "https://www.sourcesecurity.com/climax-technology-hybrid-panel-intruder-alarm-system-control-panel-technical-details.html",
    specs: {"series":"Hybrid","zonesMax":0,"zonesOnboard":0,"partitions":8,"grade":2,"communicators":["Ethernet","GSM-LTE","wireless"]},
  },
];
